import { varColor } from "../../utils/themeHelpers";

export const ScrollbarStyles = {
    "::-webkit-scrollbar": {
        width: "8px",
    },

    "::-webkit-scrollbar-thumb": {
        borderRadius: 0,
        backgroundColor: varColor("primary", "module"),
    },

    "::-webkit-scrollbar-thumb:hover": {
        backgroundColor: varColor("primary", "steel02"),
    },
};
